export const DEFAULT_DELETION_DAYS_REMAINING = 30;
export const ACCOUNT_DELETION_CARD_TITLE_PREFIX = "Your account is scheduled to delete in";
export const ACCOUNT_DELETION_CARD_BADGE = "Scheduled Deletion";
